export default "__VITE_ASSET__DsTAz_y$__"